import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const giveawayApi = createApi({
  reducerPath: 'giveaway',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['Giveaway'],
  endpoints: (builder) => ({
    getGiveaways: builder.query({
      query: ({ page, limit, keyword, status }) => {
        let url = '/giveaway';
        if (page) {
          url += `?page=${page}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        if (keyword) {
          url += `&keyword=${keyword}`;
        }
        if (status) {
          url += `&status=${status}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['Giveaway'],
      transformResponse: (response) => ({
        data: response.data,
        meta: response.meta,
      }),
    }),
    getGiveawayById: builder.query({
      query: (id) => ({
        url: `/giveaways/${id}`,
        method: 'GET',
      }),
      providesTags: ['Giveaway'],
    }),
    createGiveaway: builder.mutation({
      query: (data) => {
        return {
          url: `/giveaway`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['Giveaway'],
    }),
    updateGiveaway: builder.mutation({
      query: ({ id, data }) => ({
        url: `/giveaway/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Giveaway'],
    }),
    promoCodeClicks: builder.mutation({
      query: ({ id, data }) => ({
        url: `/giveaway/${id}/promo-code-click`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Giveaway'],
    }),
    deleteGiveaway: builder.mutation({
      query: (id) => ({
        url: `/giveaways/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Giveaway'],
    }),
    getPuclicGiveawaay: builder.query({
      query: ({ page, limit, keyword, status }) => {
        let url = '/giveaway/public';
        if (page) {
          url += `?page=${page}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        if (keyword) {
          url += `&keyword=${keyword}`;
        }
        if (status) {
          url += `&status=${status}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      transformResponse: (response) => ({
        data: response.data,
        meta: response.meta,
      }),
      providesTags: ['Giveaway'],
    }),
    getgiveawwayParticipated: builder.query({
      query: ({ page, limit, keyword, status }) => {
        let url = '/giveaway/user';
        if (page) {
          url += `?page=${page}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        if (keyword) {
          url += `&keyword=${keyword}`;
        }
        if (status) {
          url += `&status=${status}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['Giveaway'],
    }),
    getAvailableGiveawayForParticipation: builder.query({
      query: ({ page, limit, keyword, status, category }) => {
        let url = '/giveaway/available/user';
        if (page) {
          url += `?page=${page}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        if (keyword) {
          url += `&keyword=${keyword}`;
        }
        if (status) {
          url += `&status=${status}`;
        }
        if (category) {
          url += `&category=${category}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      transformResponse: (response) => ({
        data: response.data,
        meta: response.meta,
      }),
      providesTags: ['Giveaway'],
    }),
    createGiveawayParticipation: builder.mutation({
      query: ({ id }) => ({
        url: `/giveaway/${id}/participate`,
        method: 'POST',
      }),
      invalidatesTags: ['Giveaway'],
    }),
    getGiveawayAdsById: builder.query({
      query: ({ id }) => ({
        url: `/giveaway/${id}/ads`,
        method: 'GET',
      }),
      providesTags: ['Giveaway'],
    }),
    getGiveawayDetailsById: builder.query({
      query: ({ id }) => ({
        url: `/giveaway/${id}`,
        method: 'GET',
      }),
      providesTags: ['Giveaway'],
    }),
    chooseGiveawayWinner: builder.mutation({
      query: (id) => ({
        url: `/giveaway/${id}/choose-winners`,
        method: 'POST',
      }),
      invalidatesTags: ['Giveaway'],
    }),
    getParticipantInGiveaway: builder.query({
      query: ({ id, page, limit }) => {
        let url = `/giveaway/${id}/participants`;
        if (page) {
          url += `?page=${page}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['Giveaway'],
    }),
    getUserParticipantInGiveaway: builder.query({
      query: ({ id, page, limit }) => {
        let url = `/giveaway/user/participated?userId=${id}`;

        if (page) {
          url += `&page=${page}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['Giveaway'],
    }),
  }),
});

export const {
  useGetGiveawaysQuery,
  useGetGiveawayByIdQuery,
  useCreateGiveawayMutation,
  useUpdateGiveawayMutation,
  useDeleteGiveawayMutation,
  useGetPuclicGiveawaayQuery,
  useGetgiveawwayParticipatedQuery,
  useGetAvailableGiveawayForParticipationQuery,
  useCreateGiveawayParticipationMutation,
  useGetGiveawayAdsByIdQuery,
  useGetGiveawayDetailsByIdQuery,
  useChooseGiveawayWinnerMutation,
  useLazyGetGiveawayAdsByIdQuery,
  usePromoCodeClicksMutation,
  useGetParticipantInGiveawayQuery,
  useGetUserParticipantInGiveawayQuery,
} = giveawayApi;
